<template>
  <b-container fluid>
    <div
      class="floating-container"
      v-bind:class="[
        selectedIds.length > 0
          ? 'floating-container--slide-in'
          : 'floating-container--slide-out',
      ]"
    >
      <iq-card class="shadow">
        <template v-slot:body>
          <div class="d-flex flex-direction-row align-items-center">
            <b-button
              variant="outline-success"
              class="mr-4"
              style="font-size: 10px; width: 5rem"
              size="lg"
              @click="addContacts"
              >Add</b-button
            >
            <p class="h4 text-center selected-text mb-0">
              {{ selectedIds.length }} selected
            </p>
            <b-button
              variant="outline-danger"
              class="ml-4"
              style="font-size: 10px; width: 5rem"
              size="lg"
              @click="removeContacts"
              >Remove</b-button
            >
          </div>
        </template>
      </iq-card>
    </div>

    <b-row class="d-flex align-items-center mb-4">
      <b-col sm="9">
        <EditableTitle
          :value="list.name"
          v-on:valueChanged="nameChangeHandler"
          v-if="list !== null"
          :editable="$acl('lists.update.name') && isOwner"
        />
      </b-col>
      <b-col
        sm="3"
        class="d-flex flex-direction-row align-items-end justify-content-end"
      >
        <div class="mr-2">
          <h3>{{ contactIdsInList.length }} in list</h3>
        </div>
        <div
          class="
            custom-control
            custom-switch
            custom-switch-text
            custom-control-inline
            custom-switch-color
          "
        >
          <div class="custom-switch-inner">
            <p class="mb-0">Show</p>
            <input
              type="checkbox"
              class="custom-control-input bg-success"
              :id="'customSwitch-11'"
              v-model="showList"
            />
            <label
              class="custom-control-label custom-control-label-big"
              :for="'customSwitch-11'"
            ></label>
          </div>
        </div>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <iq-card>
          <template v-slot:body>
            <b-row>
              <b-col>
                <b-form-group class="mb-0">
                  <label for="searchInput">Search by</label>
                  <b-form-input
                    id="searchInput"
                    type="text"
                    placeholder="enter company name, IN or contact email"
                    size="sm"
                    v-model="search"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group class="mb-0">
                  <label for="searchInput">Potential</label>
                  <b-form-input
                    id="businessPotentialFromInput"
                    type="number"
                    size="sm"
                    placeholder="min."
                    v-model="businessPotentialFrom"
                    class="mb-1"
                  ></b-form-input>
                  <b-form-input
                    id="businessPotentialToInput"
                    type="number"
                    size="sm"
                    placeholder="max."
                    v-model="businessPotentialTo"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group class="mb-0">
                  <label for="searchInput">Potential use</label>
                  <b-form-input
                    id="businessPotentialUseFromInput"
                    type="number"
                    size="sm"
                    placeholder="min."
                    v-model="businessPotentialUseFrom"
                    class="mb-1"
                  ></b-form-input>
                  <b-form-input
                    id="businessPotentialUseToInput"
                    type="number"
                    size="sm"
                    placeholder="max."
                    v-model="businessPotentialUseTo"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group class="mb-0">
                  <label for="searchInput">Used Products</label>
                  <b-form-input
                    id="numberOfUsedProductsFromInput"
                    type="number"
                    size="sm"
                    placeholder="min."
                    v-model="numberOfUsedProductsFrom"
                    class="mb-1"
                  ></b-form-input>
                  <b-form-input
                    id="numberOfUsedProductsToInput"
                    type="number"
                    size="sm"
                    placeholder="max."
                    v-model="numberOfUsedProductsTo"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group class="mb-0">
                  <label for="searchInput">Billing</label>
                  <b-form-input
                    id="currentBillingMonthlyFromInput"
                    type="number"
                    size="sm"
                    placeholder="min."
                    v-model="currentBillingMonthlyFrom"
                    class="mb-1"
                  ></b-form-input>
                  <b-form-input
                    id="currentBillingMonthlyToInput"
                    type="number"
                    size="sm"
                    placeholder="max."
                    v-model="currentBillingMonthlyTo"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group class="mb-0">
                  <label for="searchInput">First X items</label>
                  <b-form-input
                    id="showFirstX"
                    type="number"
                    size="sm"
                    placeholder="x"
                    v-model="showFirstX"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group class="mb-0">
                  <label for="searchInput">Primary</label>
                  <b-form-select
                    plain
                    v-model="showContacts"
                    size="sm"
                    class="mb-3"
                  >
                    <template v-slot:first>
                      <b-form-select-option value>all</b-form-select-option>
                    </template>
                    <b-form-select-option value="primary"
                      >primary</b-form-select-option
                    >
                    <b-form-select-option value="non-primary"
                      >non-primary</b-form-select-option
                    >
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
          </template>
        </iq-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col lg="12">
        <b-row>
          <b-col>
            <iq-card>
              <template v-slot:body>
                <b-table
                  hover
                  responsive
                  :items="items"
                  :fields="fields"
                  class="mb-0 table-borderless"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  sort-icon-left
                  head-variant="light"
                  data-cy="list-contacts-table"
                  :tbody-tr-class="rowClass"
                >
                  <template #head(check)>
                    <b-form-checkbox
                      v-if="$acl('lists.update.*')"
                      id="globalCheckbox"
                      v-model="globalCheckbox"
                      name="globalCheckbox"
                      :disabled="!isOwner"
                    ></b-form-checkbox>
                  </template>
                  <template v-slot:cell(check)="data">
                    <b-form-checkbox-group
                      v-if="$acl('lists.update.*')"
                      :id="'checkbox' + data.item.id"
                      v-model="selectedIds"
                      :name="data.item.id"
                      :disabled="!isOwner"
                    >
                      <b-form-checkbox :value="data.item.id"></b-form-checkbox>
                    </b-form-checkbox-group>
                  </template>
                  <template v-slot:cell(id)="data">{{
                    data.item.id | notAvailable
                  }}</template>
                  <template v-slot:cell(in)="data">{{
                    data.item.in | notAvailable
                  }}</template>
                  <template v-slot:cell(company_name)="data">{{
                    data.item.company_name | notAvailable
                  }}</template>
                  <template v-slot:cell(cx)="data">{{
                    data.item.cx | notAvailable
                  }}</template>
                  <template v-slot:cell(company_business_potential)="data">{{
                    data.item.company_business_potential | notAvailable
                  }}</template>
                  <template v-slot:cell(company_business_potential_use)="data">
                    {{ data.item.company_business_potential_use | formatPercentage | notAvailable }}
                    {{ !!data.item.company_business_potential_use ? "%" : null }}
                  </template>
                  <template v-slot:cell(company_number_of_used_products)="data">
                    {{
                      data.item.company_number_of_used_products | notAvailable
                    }}
                  </template>
                  <template v-slot:cell(company_current_billing_monthly)="data">
                    {{
                      data.item.company_current_billing_monthly | notAvailable
                    }}
                  </template>
                  <template v-slot:cell(email)="data">
                    <i
                      class="fa fa-user mr-2"
                      v-if="data.item.is_primary === true"
                    ></i>
                    <i
                      class="far fa-user mr-2"
                      v-if="data.item.is_primary === false"
                    ></i>
                    {{ data.item.email | notAvailable }}
                  </template>
                  <template v-slot:cell(status)="data">
                    <ContactStatusBadge :status="data.value" />
                  </template>
                  <template v-slot:cell(company_custom_data)="data">
                    <p
                      v-if="data.item.company_custom_data === {}"
                      class="custom-data"
                    >
                      -
                    </p>
                    <p
                      v-for="(cf, idx) in data.item.company_custom_data"
                      v-bind:key="idx"
                      class="custom-data"
                      style="margin-bottom: 0"
                    >
                      <strong>{{ idx | customFieldColumnName }}</strong>
                      : {{ cf }}
                    </p>
                  </template>
                  <template v-slot:cell(custom_data)="data">
                    <p
                      v-if="data.item.companyCustomData === {}"
                      class="custom-data"
                    >
                      -
                    </p>
                    <p
                      v-for="(cf, idx) in data.item.custom_data"
                      v-bind:key="idx"
                      style="margin-bottom: 0"
                      class="custom-data"
                    >
                      <strong>{{ idx | customFieldColumnName }}</strong>
                      : {{ cf }}
                    </p>
                  </template>
                  <template v-slot:cell(action)="data">
                    <b-button
                      v-if="
                        data.item.id !== null &&
                        contactIdsInList.indexOf(data.item.id) === -1 &&
                        $acl('lists.update.*') &&
                        isOwner
                      "
                      variant="outline-success mr-2"
                      @click="() => addToList([data.item.id])"
                      >Add</b-button
                    >
                    <b-button
                      v-if="
                        contactIdsInList.indexOf(data.item.id) > -1 &&
                        $acl('lists.update.*') &&
                        isOwner
                      "
                      variant="outline-danger mr-2"
                      @click="() => removeFromList([data.item.id])"
                      >Remove</b-button
                    >
                  </template>
                </b-table>
              </template>
            </iq-card>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { core } from "../../config/pluginInit";
import gql from "graphql-tag";
import EditableTitle from "./Components/EditableTitle.vue";
import { composedContact } from "../../Utils/composedContact";
import IqCard from "../../components/core/cards/iq-card.vue";
import ContactStatusBadge from "./Components/ContactStatusBadge";
import { getAccountSync } from "../../Utils/account";

const GET_LIST = gql`
  query getList($id: uuid!) {
    lists_by_pk(id: $id) {
      id
      name
      owner_id
      lists_contacts {
        contact {
          id
          first_name
          last_name
          email
          phone
        }
      }
    }
  }
`;
const RENAME_LIST = gql`
  mutation renameList($listId: uuid!, $name: String!) {
    update_lists_by_pk(pk_columns: { id: $listId }, _set: { name: $name }) {
      id
      name
    }
  }
`;
const LIST_CONTACTS = gql`
  query listContacts {
    contacts {
      id
      first_name
      last_name
      status
      email
      phone
    }
  }
`;
const LIST_CONTACTS_WITH_COMPANIES = gql`
  query listContactsWithCompanies(
    $where: contacts_with_companies_bool_exp!
    $limit: Int
    $order_by: [contacts_with_companies_order_by!]
  ) {
    contacts_with_companies(order_by: $order_by, where: $where, limit: $limit) {
      id
      email
      first_name
      last_name
      cx
      custom_data
      company_id
      company_name
      company_in
      company_business_potential
      company_business_potential_use
      company_number_of_used_products
      company_current_billing_monthly
      company_custom_data
      company_primary_contact_id
      is_primary
      status
    }
    contacts_with_companies_aggregate {
      aggregate {
        count
      }
    }
  }
`;
const ADD_CONTACTS_TO_LIST = gql`
  mutation addContactsToList(
    $listsContactsInputs: [lists_contacts_insert_input!]!
  ) {
    insert_lists_contacts(
      objects: $listsContactsInputs
      on_conflict: { constraint: lists_contacts_pkey, update_columns: [] }
    ) {
      affected_rows
    }
  }
`;
const REMOVE_CONTACTS_FROM_LIST = gql`
  mutation deleteContactsInList($listId: uuid!, $contactIds: [uuid!]!) {
    delete_lists_contacts(
      where: {
        _and: [
          { list_id: { _eq: $listId } }
          { contact_id: { _in: $contactIds } }
        ]
      }
    ) {
      affected_rows
    }
  }
`;

export default {
  name: "ListsEdit",
  components: { EditableTitle, IqCard, ContactStatusBadge },
  data() {
    return {
      loading: false,
      showList: false,
      editableName: false,
      selectedContactId: "",
      selectedIds: [],
      list: null,
      contacts: [],
      contactsWithCompanies: [],
      sortBy: "company_name",
      sortDesc: false,
      search: "",
      perPage: 25,
      currentPage: 1,
      businessPotentialFrom: "",
      businessPotentialTo: "",
      businessPotentialUseFrom: "",
      businessPotentialUseTo: "",
      numberOfUsedProductsFrom: "",
      numberOfUsedProductsTo: "",
      currentBillingMonthlyFrom: "",
      currentBillingMonthlyTo: "",
      showFirstX: "",
      showContacts: "",
      fields: [
        { key: "check", label: "check", sortable: false },
        { key: "company_name", label: "Company", sortable: true },
        { key: "cx", label: "CX", sortable: true },
        {
          key: "email",
          label: "Email",
          sortable: true
        },
        {
          key: "status",
          label: "Status",
          sortable: true
        },
        {
          key: "company_business_potential",
          label: "Potential",
          sortable: true
        },
        {
          key: "company_business_potential_use",
          label: "Potential use",
          sortable: true
        },
        {
          key: "company_number_of_used_products",
          label: "Used products",
          sortable: true
        },
        {
          key: "company_current_billing_monthly",
          label: "Billing",
          sortable: true
        },

        {
          key: "company_custom_data",
          label: "Company data",
          sortable: false
        },
        {
          key: "custom_data",
          label: "Contact data",
          sortable: false
        },
        { key: "action", label: "Action", sortable: false }
      ],
      globalCheckbox: false,
    };
  },
  apollo: {
    list() {
      return {
        query: GET_LIST,
        fetchPolicy: "no-cache",
        variables: {
          id: this.$route.params.id
        },
        update: data => data.lists_by_pk
      };
    },
    contacts: {
      query: LIST_CONTACTS,
      fetchPolicy: "no-cache"
    },
    contactsWithCompanies() {
      return {
        query: LIST_CONTACTS_WITH_COMPANIES,
        fetchPolicy: "no-cache",
        variables() {
          const vars = {
            where: {},
            limit: this.showFirstX ? parseInt(this.showFirstX) : undefined
          };

          if (this.sortBy !== "") {
            vars.order_by = {
              [this.sortBy]: this.sortDesc ? "desc" : "asc"
            };
          }

          // filter
          const searchPart = this.search
            ? {
                _or: [
                  {
                    company_name: {
                      _ilike: `%${this.search}%`
                    }
                  },
                  {
                    company_in: {
                      _ilike: `%${this.search}%`
                    }
                  },
                  {
                    email: {
                      _ilike: `%${this.search}%`
                    }
                  }
                ]
              }
            : null;

          const whereAttributes = [];

          // BUSINESS POTENTIAL
          if (this.businessPotentialFrom) {
            whereAttributes.push({
              company_business_potential: {
                _gte: parseFloat(this.businessPotentialFrom)
              }
            });
          }
          if (this.businessPotentialTo) {
            whereAttributes.push({
              company_business_potential: {
                _lte: parseFloat(this.businessPotentialTo)
              }
            });
          }

          // BUSINESS POTENTIAL USE
          if (this.businessPotentialUseFrom) {
            whereAttributes.push({
              company_business_potential_use: {
                _gte: parseFloat(this.businessPotentialUseFrom)
              }
            });
          }
          if (this.businessPotentialUseTo) {
            whereAttributes.push({
              company_business_potential_use: {
                _lte: parseFloat(this.businessPotentialUseTo)
              }
            });
          }

          // NUMBER OF USED PRODUCTS
          if (this.numberOfUsedProductsFrom) {
            whereAttributes.push({
              company_number_of_used_products: {
                _gte: parseInt(this.numberOfUsedProductsFrom)
              }
            });
          }
          if (this.numberOfUsedProductsTo) {
            whereAttributes.push({
              company_number_of_used_products: {
                _lte: parseInt(this.numberOfUsedProductsTo)
              }
            });
          }

          // CURRENT BILLING MONTHLY
          if (this.currentBillingMonthlyFrom) {
            whereAttributes.push({
              company_current_billing_monthly: {
                _gte: parseFloat(this.currentBillingMonthlyFrom)
              }
            });
          }
          if (this.currentBillingMonthlyTo) {
            whereAttributes.push({
              company_current_billing_monthly: {
                _lte: parseFloat(this.currentBillingMonthlyTo)
              }
            });
          }

          // SHOW CONTACTS
          if (this.showContacts === "primary") {
            whereAttributes.push({
              is_primary: {
                _eq: true
              }
            });
          }
          if (this.showContacts === "non-primary") {
            whereAttributes.push({
              is_primary: {
                _eq: false
              }
            });
          }

          // IN LIST
          if (this.showList) {
            whereAttributes.push({
              id: {
                _in: this.contactIdsInList
              }
            });
          }

          const finalFilter = [];
          if (searchPart !== null) {
            finalFilter.push(searchPart);
          }
          if (whereAttributes.length > 0) {
            whereAttributes.forEach(att => finalFilter.push(att));
          }

          vars.where = {
            _and: finalFilter
          };

          return vars;
        },
        update: data => {
          return data.contacts_with_companies;
        },
        result({ data, loading, networkStatus }) {
          if (!loading) {
            this.rows = data.contacts_with_companies_aggregate.aggregate.count;
          }
        }
      };
    }
  },
  computed: {
    items() {
      const d = this.contactsWithCompanies.map(c => c);
      return d;
    },
    contactIdsInList() {
      return this?.list?.lists_contacts?.map(i => i.contact.id) || [];
    },
    contactList() {
      return this.list.lists_contacts.map(i => ({
        ...i,
        pretty: composedContact({
          email: i.contact.email,
          firstName: i.contact.first_name,
          lastName: i.contact.last_name
        })
      }));
    },
    isOwner(){
      return getAccountSync().userId === this.list?.owner_id;
    }
  },
  methods: {
    toggleSelectedItem(id) {
      const selectedIdIdx = this.selectedIds.indexOf(id);
      if (selectedIdIdx === -1) {
        this.selectedIdIdx = [...this.selectedIdIdx, id];
      } else {
        this.selectedIdIdx = this.selectedIdIdx.filter(i => i !== id);
      }
    },
    toggleAllIds(v) {
      if (v === true) {
        this.selectedIds = this.contactsWithCompanies.map(c => c.id);
      }
      if (v === false) {
        this.selectedIds = [];
      }
    },
    async submitHandler(id) {
      await this.addToList([id]);
      this.selectedContactId = "";
    },
    async addToList(contactIds) {
      const listsContactsInputs = contactIds.map(contactId => ({
        list_id: this.$route.params.id,
        contact_id: contactId
      }));
      try {
        const r = await this.$apollo.mutate({
          mutation: ADD_CONTACTS_TO_LIST,
          variables: {
            listsContactsInputs
          }
        });
        this.$apollo.queries.list.refetch();
        this.$toast.success(
          `${r?.data?.insert_lists_contacts?.affected_rows} added`
        );
      } catch (error) {
        this.$toast.error(`Failed to add contact: ${error.message}`);
      }
    },
    async removeFromList(contactIds) {
      try {
        const r = await this.$apollo.mutate({
          mutation: REMOVE_CONTACTS_FROM_LIST,
          variables: {
            listId: this.$route.params.id,
            contactIds
          }
        });
        this.$apollo.queries.list.refetch();
        this.$toast.success(
          `${r?.data?.delete_lists_contacts?.affected_rows} removed`
        );
      } catch (error) {
        this.$toast.error(`Failed to remove: ${error.message}`);
      }
    },
    async nameChangeHandler(value) {
      try {
        const r = await this.$apollo.mutate({
          mutation: RENAME_LIST,
          variables: {
            listId: this.$route.params.id,
            name: value
          }
        });
        if (r?.data?.update_lists_by_pk?.name) {
          this.list.name = r.data.update_lists_by_pk.name;
        }
        this.$toast.success(`List renamed`);
      } catch (error) {
        this.$toast.error(`Failed to rename list: ${error.message}`);
      }
    },
    rowClass(item, type) {
      if (this.contactIdsInList.indexOf(item.id) > -1) {
        return "table-success";
      }
    },
    async addContacts() {
      await this.addToList(this.selectedIds);
      this.selectedIds = [];
      this.globalCheckbox = false;
    },
    async removeContacts() {
      await this.removeFromList(this.selectedIds);
      this.selectedIds = [];
      this.globalCheckbox = false;
    },
    resetFilter() {
      this.businessPotentialFrom = "";
      this.businessPotentialTo = "";
      this.businessPotentialUseFrom = "";
      this.businessPotentialUseTo = "";
      this.numberOfUsedProductsFrom = "";
      this.numberOfUsedProductsTo = "";
      this.currentBillingMonthlyFrom = "";
      this.currentBillingMonthlyTo = "";
      this.search = "";
      this.showFirstX = "";
      this.showContacts = "";
    }
  },
  watch: {
    globalCheckbox: function(v) {
      this.toggleAllIds(v);
    },
    showList: function() {
      this.selectedIds = [];
      this.resetFilter();
    }
  },
  mounted() {
    core.index();
  }
};
</script>
<style scoped>
.editable {
  padding: 0.5rem;
}
.editable:hover {
  cursor: text;
  border: black 1px solid;
  border-radius: 15px;
}
.custom-data {
  font-size: 10px !important;
}
.non-selectable {
  cursor: not-allowed !important;
}
.custom-control-label-big {
  width: 69px !important;
  height: 30px !important;
}
.custom-control-label-big::before {
  height: 32px !important;
}
.custom-control-label-big::after {
  height: 30px !important;
  width: 41px !important;
}
.floating-container {
  width: 33%;
  right: 25%;
  position: fixed;
  /* right: 3rem; */
  bottom: -10rem;
  z-index: 1;
  display: flex;
}
@media screen and (max-width: 1366px) {
  .floating-container {
    right: 33%;
  }
}
.floating-container--slide-in {
  animation: slideIn;
  animation-duration: 0.5s;
  bottom: 0rem;
}
.floating-container--slide-out {
  animation: slideOut;
  animation-duration: 0.5s;
  bottom: -10rem;
}
@keyframes slideIn {
  from {
    bottom: -10rem;
    opacity: 0;
  }
  to {
    bottom: 0;
    opacity: 1;
  }
}
@keyframes slideOut {
  from {
    bottom: 0;
    opacity: 1;
  }
  to {
    bottom: -10rem;
    opacity: 0;
  }
}
</style>
